import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './about.html',
  styleUrl: './about.scss',
})
export class About {
  focusAreas = [
    'Client software delivery across web, mobile, and cloud',
    'Company-built products in healthcare, HR, and finance',
    'End-to-end ownership from architecture to production',
    'Based in the Philippines · Serving businesses that need reliable systems',
  ];

  values = [
    {
      icon: 'pi-star',
      title: 'Quality delivery',
      description:
        'Every product is built with production standards — clean architecture, security, and maintainable code.',
    },
    {
      icon: 'pi-bolt',
      title: 'Full-stack ownership',
      description:
        'Web, mobile, and backend under one roof so clients get a coherent system, not fragmented handoffs.',
    },
    {
      icon: 'pi-shield',
      title: 'Real business systems',
      description:
        'From healthcare marketplaces to HRIS and finance tools — software shaped for how businesses actually operate.',
    },
  ];

  scrollTo(href: string) {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }
}
